import { get } from 'lodash-es';
import {
  DEALERS_WEB_SITES,
  CARVANA,
  CARMAX,
  JAKE_SWEENEY_EXPRESS,
  HERTZ,
  HERTZ_RENT,
} from 'site-modules/shared/constants/inventory/buy-online-dealers';

// TODO: This functionality should be move into displayvin API with TED-4962
export const generateDeepLink = vinData => {
  const dealer = get(vinData, 'dealerInfo.displayInfo.parentDealershipName');
  const deepLink = get(vinData, 'deepLinkUrl', get(vinData, 'listingUrl'));

  if (deepLink) {
    const query = deepLink.substring(deepLink.indexOf('?') + 1);
    const searchParams = new URLSearchParams(query);
    const vehicleId = searchParams.get('utm_vehicle_id');

    if (dealer === CARVANA && vehicleId) {
      return `${DEALERS_WEB_SITES[dealer].webSite}/vehicle/${vehicleId}?${query}`;
    }
    return deepLink;
  }

  if (dealer === CARMAX) {
    const stockNumber = get(vinData, 'stockNumber');
    return `${DEALERS_WEB_SITES[dealer].webSite}/listing/${stockNumber}`;
  }

  if (dealer === JAKE_SWEENEY_EXPRESS) {
    return `${DEALERS_WEB_SITES[dealer].webSite}/details/${get(vinData, 'vin')}`;
  }

  if ([HERTZ, HERTZ_RENT].includes(dealer)) {
    return `${DEALERS_WEB_SITES[dealer].webSite}/catcher.esl?vin=${get(vinData, 'vin')}`;
  }

  return null;
};
